export default __webpack_public_path__ + "static/media/jonathan-victor.24d5d024.png";